
const OffersIconSVG = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40">
        <path
            fill="#F8FAFC"
            d="m29.412 22.25-7.15 7.15q-.3.3-.675.45t-.75.15-.75-.15q-.374-.15-.675-.45l-8.825-8.825a1.975 1.975 0 0 1-.575-1.4V12q0-.824.588-1.413A1.93 1.93 0 0 1 12.012 10h7.176q.399 0 .774.162.375.163.65.438l8.8 8.825q.3.3.438.675t.137.75-.137.737a1.9 1.9 0 0 1-.438.663M20.838 28l7.15-7.15L19.162 12h-7.15v7.15zm-6.326-12q.625 0 1.063-.437.438-.438.438-1.063t-.438-1.062A1.45 1.45 0 0 0 14.513 13q-.625 0-1.063.438a1.45 1.45 0 0 0-.437 1.062q0 .624.437 1.063.438.437 1.063.437"
        ></path>
    </svg>
);

export default OffersIconSVG;
